var isMobile = function() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ); 
};

const isAppleDevice = function() {
    return (/iPhone|iPad|iPod/i.test(navigator.userAgent) ); 
};